import React from 'react'
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  Box,
  Divider,
} from '@mui/material'

export interface ListSkeletonProps {
  /** Number of list items to render. Default: 6 */
  count?: number
}

export const ListSkeleton: React.FC<ListSkeletonProps> = ({ count = 6 }) => {
  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>
          <ListItem sx={{ py: 2 }}>
            <ListItemAvatar>
              <Skeleton variant="circular" width={40} height={40} />
            </ListItemAvatar>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Skeleton variant="text" width="40%" height={20} />
                  <Skeleton variant="text" width="20%" height={16} />
                </Box>
              }
              secondary={
                <Box sx={{ mt: 1 }}>
                  <Skeleton variant="text" width="80%" height={16} />
                </Box>
              }
            />
          </ListItem>
          {index < count - 1 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  )
}

export default ListSkeleton
